import SearchCases from "../pages/search/NewThemeSearch";
import Cases from "../pages/cases/NewThemeCases";
import TaskList from "../pages/tasklist/NewThemeTaskList";
import Registration from "../pages/registration/NewThemeRegistration";
import SeeIndividualRecord from "../pages/seeIndividualRecord/SeeIndividualRecord";
import AlertsPage from "../pages/alerts/NewThemeAlerts";
import Appointments from "../pages/appointment/appointmentsnew";
import MobileSearch from "../pages/mobileSearch/mobileSearch";
import ReferralCases from "../pages/referralCases/NewThemeReferralCases";
import DataEntry from "../pages/dataEntry/DataEntry";
import ReferedCase from "../component/referedCases/ReferedCase";
import Survey from "../pages/dataEntry/Survey";
import SurveyListing from "../pages/dataEntry/SurveyListing";
import Settings from "../pages/settings/Settings";
import Prescreen from "../pages/prescreening/Prescreen";
import IndividualCases from "../pages/individualCases/IndividualCases";
import offlineCases from "../pages/offlineCases/Cases";
import CasesList from "../pages/casesList/NewThemeCases";
import HomepageContainer from "../pages/home/HomepageContainer";
import PatientCard from "../pages/patientcard/PatientCard";
import ContactTaskList from "../pages/tasklist/ContactTaskList";
import DeactivatedCases from "../pages/casesLineList/DeactivatedCasesList";
import CasesLineList from "../pages/casesLineList/CasesLineList";
import DatsetManagement from "../pages/dataEntry/DatsetManagement";
import Dashboard from "../pages/dashboard/Dashboard";
import LineListDashboard from "../pages/dashboard/LineListDashboard";
import MonthlyReportDashboard from "../pages/dashboard/MonthlyReportDashboard";
import ApprovalRequests from "../pages/dashboard/ApprovalRequests";
import InventoryManagement from "../pages/inventorymanagement/index";
import ActivityManagement from "../pages/activityManagement/ActivityManagement";
// Some folks find value in a centralized route config.
// A route config is just data. React is great at mapping
// data into components, and <Route> is a component.

// Our route config is just an array of logical "routes"
// with `path` and `component` props, ordered the same
// way you'd do inside a `<Switch>`.
const routes = [
  {
    path: "/layout/home",
    name: "home",
    displayName: "home",
    component: HomepageContainer, //NewHomePage,
    // component: InventoryManagement, //NewHomePage,
  },
  {
    path: "/layout/search",
    name: "search",
    displayName: "search",
    component: SearchCases,
  },
  {
    path: "/layout/cases",
    name: "cases",
    displayName: "cases",
    component: Cases,
  },
  {
    path: "/layout/registration",
    name: "registration",
    displayName: "registration",
    component: Registration,
  },
  {
    path: "/layout/individualrecord",
    name: "SeeIndividualRecord",
    displayName: "SeeIndividualRecord",
    component: SeeIndividualRecord,
  },
  {
    path: "/layout/referedcase",
    name: "referedcase",
    displayName: "referedcase",
    component: ReferedCase,
  },
  {
    path: "/layout/referral",
    name: "referral",
    displayName: "referral",
    component: ReferralCases,
  },
  {
    path: "/layout/alerts",
    name: "alerts",
    displayName: "alerts",
    component: AlertsPage,
  },
  {
    path: "/layout/appointments",
    name: "appointments",
    displayName: "appointments",
    component: Appointments,
  },
  {
    path: "/layout/searchMobile",
    name: "searchMobile",
    displayName: "searchMobile",
    component: MobileSearch,
  },
  {
    path: "/layout/individual-cases-list",
    name: "IndividualCases",
    displayName: "IndividualCases",
    component: IndividualCases,
  },
  {
    path: "/layout/offline-clients",
    name: "OfflineCilents",
    displayName: "OfflineCilents",
    component: offlineCases,
  },
  {
    path: "/layout/dataentry",
    name: "DataEntry",
    displayName: "DataEntry",
    component: DataEntry,
  },
  {
    path: "/layout/datasetmanagement",
    name: "DatsetManagement",
    displayName: "DatsetManagement",
    component: DatsetManagement,
  },
  {
    path: "/layout/contactTaskList",
    name: "ContactTaskList",
    displayName: "ContactTaskList",
    component: ContactTaskList,
  },
  {
    path: "/layout/survey",
    name: "Survey",
    displayName: "Survey",
    component: Survey,
  },
  {
    path: "/layout/surveylisting",
    name: "SurveyListing",
    displayName: "SurveyListing",
    component: SurveyListing,
  },
  {
    path: "/layout/tasklist",
    name: "tasklist",
    displayName: "tasklist",
    component: TaskList,
  },
  {
    path: "/layout/settings",
    name: "tasklist",
    displayName: "tasklist",
    component: Settings,
  },
  {
    path: "/layout/prescreen",
    name: "prescreening",
    displayName: "prescreening",
    component: Prescreen,
  },
  {
    path: "/layout/caseslist",
    name: "caseslist",
    displayName: "caseslist",
    component: CasesList,
  },
  {
    path: "/layout/patientcard",
    name: "patientcard",
    displayName: "patientcard",
    component: PatientCard,
  },
  {
    path: "/layout/deactivatecases",
    name: "deactivatecases",
    displayName: "deactivatecases",
    component: DeactivatedCases,
  },
  {
    path: "/layout/linelist",
    name: "linelist",
    displayName: "linelist",
    component: CasesLineList,
  },
  {
    path: "/layout/dashboard",
    name: "dashboard",
    displayName: "dashboard",
    component: Dashboard,
  },
  {
    path: "/layout/inventorymanagement",
    name: "Inventory Management",
    displayName: "Inventory Management",
    component: InventoryManagement,
  },
  {
    path: "/layout/linelistdashboard",
    name: "Line List",
    displayName: "Line List",
    component: LineListDashboard,
  },
  {
    path: "/layout/monthlydashboard",
    name: "Monthly Report",
    displayName: "Monthly Report",
    component: MonthlyReportDashboard,
  },
  {
    path: "/layout/approvalRequests",
    name: "Approval Requests",
    displayName: "Approval Requests",
    component: ApprovalRequests,
  },
  {
    path: "/layout/Performancereport",
    name: "Performance Report",
    displayName: "Performance Report",
    component: ApprovalRequests,
  },
  {
    path: "/layout/Activitymodule",
    name: "Activity Management",
    displayName: "Activity Management",
    component: ActivityManagement,
  },
  {
    redirect: true,
    to: "/layout/home",
    path: "/",
    name: "home",
    displayName: "home",
    // component: NewHomePage,
  },
];

export default routes;
